import {
  GAMECDK_SET_VISIBLE,
  GAMECDK_CREATE_QRCODE_SUCCESS,
  GAMECDK_POLL_SUCCESS,
  GAMECDK_CODE_VISIBLE,
  GAMECDK_CODE_GET_DESC_SUCCESS,
} from '../constants/gamecdk';

const initState = {
  gamecdkVisible: {
    isShow: false,
  },
  gamecdkQRcode: {
    loading: 0,
  },
  gamecdkPolls: {
    index: 0,
  },
  gamecdkCodeShow: {
    isShow: false,
    exchangeUrl: '',
  },
  gamecdkDesc: { description: '' },
};

const gamecdk = (state = initState, action = {}) => {
  switch (action.type) {
    case GAMECDK_SET_VISIBLE:
      if (action.param?.isShow === false) {
        return {
          ...state,
          gamecdkVisible: {
            isShow: false,
          },
          gamecdkQRcode: {
            loading: 0,
          },
          gamecdkPolls: {
            index: 0,
          },
        };
      }
      return {
        ...state,
        gamecdkVisible: action.param,
      };
    case GAMECDK_CREATE_QRCODE_SUCCESS:
      return { ...state, gamecdkQRcode: action.data };
    case GAMECDK_POLL_SUCCESS:
      return { ...state, gamecdkPolls: action.data };
    case GAMECDK_CODE_VISIBLE:
      return { ...state, gamecdkCodeShow: action.param };
    case GAMECDK_CODE_GET_DESC_SUCCESS:
      return { ...state, gamecdkDesc: action.data };
    default:
      return state;
  }
};

export default gamecdk;
